<template>
  <!-- 🌿 Banner -->
  <section class="pt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div
            class="card overflow-hidden h-100px h-xl-200px rounded-3"
            style="
              background-image: url(/assets/images/bg/fondo-acercade-viaverde.jpg);
              background-position: center left;
              background-size: cover;
            "
          >
            <div class="bg-overlay bg-dark opacity-6"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 📚 Lista de publicaciones -->
  <div class="container my-4">
    <div v-if="publicationStore.loading" class="text-center py-5">
      <div class="spinner-border text-success" role="status"></div>
      <p class="mt-2">Cargando publicaciones...</p>
    </div>

    <div v-else-if="publicationStore.error" class="alert alert-danger">
      {{ publicationStore.error }}
    </div>

    <div v-else>
      <div class="row g-4">
        <div
          v-for="item in publicationStore.publications"
          :key="item.id"
          class="col-sm-6 col-lg-4 col-xl-3"
        >
          <div class="card shadow h-100">
            <div class="position-relative">
              <img
                :src="item.image_path || '/assets/images/placeholder.jpg'"
                class="card-img-top"
                alt="Imagen de publicación"
              />
              <div class="card-img-overlay d-flex z-index-0 p-3">
                <div class="w-100 mb-auto d-flex justify-content-end">
                  <div class="icon-md bg-dark rounded-circle fs-5">
                    <button
                      class="btn btn-link text-white p-0"
                      @click="downloadPublication(item.id, item.title)"
                    >
                      <i class="bi bi-file-earmark-pdf"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-3">
              <h5 class="card-title mb-0">
                <a
                  href="#"
                  @click.prevent="goToDetail(item.id)"
                  class="stretched-link"
                >
                  {{ item.title }}
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>

      <!-- 🔄 Paginación -->
      <nav
        v-if="publicationStore.totalPages > 1"
        class="mt-4 d-flex justify-content-center"
        aria-label="navigation"
      >
        <ul
          class="pagination pagination-primary-soft d-inline-block d-md-flex rounded mb-0"
        >
          <li
            class="page-item mb-0"
            :class="{ disabled: publicationStore.currentPage === 1 }"
          >
            <button
              class="page-link"
              @click="
                publicationStore.changePage(publicationStore.currentPage - 1)
              "
            >
              <i class="fas fa-angle-double-left"></i>
            </button>
          </li>

          <li
            v-for="page in publicationStore.totalPages"
            :key="page"
            class="page-item mb-0"
            :class="{ active: page === publicationStore.currentPage }"
          >
            <button
              class="page-link"
              @click="publicationStore.changePage(page)"
            >
              {{ page }}
            </button>
          </li>

          <li
            class="page-item mb-0"
            :class="{
              disabled:
                publicationStore.currentPage === publicationStore.totalPages,
            }"
          >
            <button
              class="page-link"
              @click="
                publicationStore.changePage(publicationStore.currentPage + 1)
              "
            >
              <i class="fas fa-angle-double-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { usePublicationStore } from "@/modules/posts/stores/publications";
import apiClient from "@/plugins/axios";

export default {
  setup() {
    const router = useRouter();
    const publicationStore = usePublicationStore();

    onMounted(() => {
      publicationStore.fetchPublications();
    });

    const goToDetail = (id) => {
      router.push({ name: "post-detail", params: { id } });
    };

    const downloadPublication = async (id, title) => {
      try {
        const response = await apiClient.get(`/download-publication/${id}`, {
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${title}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        alert("Error al descargar la publicación.");
      }
    };

    return { publicationStore, goToDetail, downloadPublication };
  },
};
</script>
